import React, {FC, useState, useEffect} from "react"
import PropTypes from "prop-types"

import {injectIntl, InjectIntl} from "@irati/utils/lang"
import OnboardingService, {OnboardingStep} from "@irati/onboarding/services/onboarding"
import authentication from "@irati/auth"
import {IconTypes} from "@irati/ui/src/Icon"
import adminTracking from "@irati-tracking/admin"
import History from "@irati/utils/history"

import {WalletRoutes} from "@irati-web/wallet/src/enums/Routes"
import GlobalRewardWalletModal from "../../GlobalRewardWalletModal"
import {RelativeDiv} from "../styled"
import AdminRouterLink from "./AdminRouterLink"

interface Props extends InjectIntl {
  isCollapsed: boolean
}

interface Context {
  apps: {[key: string]: string}
  appPath: string
}

const RewardsAdminRouterLink: FC<Props> = ({isCollapsed, formatMessage}, {apps}: Context) => {
  const {WALLET} = apps
  const [showOnboarding, setShowOnboarding] = useState<boolean>(false)
  const [showModal, updateShowModal] = useState<boolean>(false)

  useEffect(() => {
    hasSeenNewRewardsPopup()
  }, [])

  const hasSeenNewRewardsPopup = () => {
    OnboardingService.get(authentication.user().uuid).then((res) => {
      const shouldShow = !res.userProgress?.find((item) => item.step === OnboardingStep.HAS_SEEN_NEW_REWARDS_POPUP)
      setShowOnboarding(shouldShow)
    })
  }

  const handleOpen = () => {
    adminTracking.navigationClickRewardsNew()
    updateShowModal(true)
  }

  const handleClose = () => History.push(WalletRoutes.FLEXI_REWARD, WALLET)

  if (!showOnboarding) {
    return (
      <RelativeDiv>
        <AdminRouterLink
          id="rewardsPageButton"
          isCollapsed={isCollapsed}
          app={WALLET}
          to={WalletRoutes.FLEXI_REWARD}
          icon={IconTypes.wallet}
          onClick={adminTracking.navigationClickRewards}
          title="platform.adminNavigation.primary.rewards"
        />
      </RelativeDiv>
    )
  }

  return (
    <>
      <RelativeDiv>
        <AdminRouterLink
          id="rewardsPageButton"
          isCollapsed={isCollapsed}
          to={window.location.pathname.split("/admin")[1]}
          icon={IconTypes.wallet}
          onClick={handleOpen}
          title="platform.adminNavigation.primary.rewards"
          ignoreSelected
        />
      </RelativeDiv>
      <GlobalRewardWalletModal showModal={showModal} onClose={handleClose} />
    </>
  )
}

RewardsAdminRouterLink.contextTypes = {
  apps: PropTypes.object.isRequired,
  appPath: PropTypes.string.isRequired
}

export default injectIntl(RewardsAdminRouterLink)
